// LLM generated - Model Claude 4 Sonnet
import React from 'react';
import { Skeleton, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.white,
    border: `1px solid ${theme.colors.gray2[0]}`,
    borderRadius: theme.radius.md,
    padding: theme.other.spacing._16,
    marginBottom: theme.other.spacing._8,
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    marginBottom: theme.other.spacing._12,
  },

  avatarContainer: {
    position: 'relative',
  },

  avatarSkeleton: {
    width: 32,
    height: 32,
    borderRadius: '50%',
  },

  badgeSkeleton: {
    position: 'absolute',
    top: -2,
    right: -2,
    width: 16,
    height: 16,
    borderRadius: '50%',
  },

  userInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._4,
  },

  handleSkeleton: {
    height: 14,
    width: '30%',
    maxWidth: 80,
  },

  timestampSkeleton: {
    height: 12,
    width: '25%',
    maxWidth: 60,
  },

  titleSkeleton: {
    height: 18,
    width: '70%',
    marginBottom: theme.other.spacing._8,
  },

  contentSkeleton: {
    height: 14,
    marginBottom: theme.other.spacing._4,
  },

  contentSkeletonShort: {
    height: 14,
    width: '80%',
  },
}));

function PostSkeleton() {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.avatarContainer}>
          <Skeleton className={classes.avatarSkeleton} />
        </div>

        <div className={classes.userInfo}>
          <Skeleton className={classes.handleSkeleton} />
          <Skeleton className={classes.timestampSkeleton} />
        </div>
      </div>

      <Skeleton className={classes.titleSkeleton} />

      <Skeleton className={classes.contentSkeleton} />
      <Skeleton className={classes.contentSkeleton} />
      <Skeleton className={classes.contentSkeletonShort} />
    </div>
  );
}

PostSkeleton.displayName = 'PostSkeleton';

export { PostSkeleton };
